module.exports = __webpack_public_path__ + "static/media/Medal_silver.188562bc.png";